import Base from './condition-base'
import renderFields from './video-finish.pug'

export default class VideoFinish extends Base
  Object.defineProperty this, "label", get: -> @t(".label")

  renderFields: renderFields
